import styled from "styled-components";

const LeftContainerStyled = styled.aside`
  display: flex;
  width: 100%;
  position: fixed;
  left: 0;
  top: 0;
  overflow: auto;
  transition: width 0.3s ease-in-out;

  &.collapsed {
    width: 11.2rem;
  }

  @media only screen and (min-width: ${props => props.theme.desktopSmall}) {
    width: 29.3rem;
	}
`;

export default LeftContainerStyled;